import client from '../../components/sanityProject/sanityClient'

export async function getAllProducts() {
  return await client.fetch(
    `*[_type == "product"]{
      _id,
      title,
      slug,
      price,
      description,
      mainImage,
      category->{
        title,
        slug
      }
    }`
  );
}

// (keep this for product detail page)
export async function getProductBySlug(slug) {
  return await client.fetch(
    `*[_type == "product" && slug.current == $slug][0]{
      _id,
      title,
      slug,
      price,
      description,
      mainImage,
      secondImage,
      thirdImage,
      category->{
        title
      }
    }`,
    { slug }
  );
}